/* eslint-disable no-constant-condition */
import classNames from 'classnames';
import loadingGif from '../../assets/Other/loading.gif';
import { useState } from 'react';
import CVItem from '../../components/CV/CVItem';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import request from '../../utils/APIHelper/request';
import { exportToExcel } from '../../utils/Downloader/Downloader';
import CopyOnCipboardArea from '../../components/CopyOnClipboardArea/CopyOnClipboardArea';
import stringTable from 'string-table';
import { refundContacts } from '../../constants/enums/RefundContacts';

const getRefundOnSaveData = (data) => {
  return data.map((item) => {
    return {
      CV: item.cv,
      'Reference Number': item.ref,
      Amount: item.amount,
    };
  });
};

const getOnCopyText = (data) => {
  let onCopy = '';
  data.forEach((item) => {
    onCopy += `--------\nCV: ${item.cv}\nReference Number: ${item.ref}\nAmount: ${item.amount}\nBranch Id: ${item.branchId}\n--------`;
  });
  return onCopy;
};

const Refund = ({ swalModal }) => {
  const [CVs, setCVs] = useState([]);
  const [CVInput, SetCVInput] = useState('');
  const [refundInfo, setRefundsInfo] = useState([]);
  const [loading, setLoading] = useState(false);

  const onEnterMethod = () => {
    const trimmedCVInput = CVInput.trim().toUpperCase();

    if (trimmedCVInput.length > 0 && !CVs.includes(trimmedCVInput)) {
      setCVs([...CVs, trimmedCVInput]);
      SetCVInput('');
    }
  };

  const onRemoveMethod = (index) => {
    setCVs(CVs.filter((_, i) => i !== index));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onEnterMethod();
    }
  };

  const showSwal = (code) => {
    swalModal.fire({
      title: 'Payment was not proceeded!',
      text: `Payment was not proceed for parcels ${CVs.join(', ')}`,
      icon: code,
      showCancelButton: true,
      showConfirmButton: false,
      cancelButtonText: 'Cancel',
      customClass: {
        confirmButton: 'bg-blue-800 text-white hover:bg-blue-900',
        cancelButton: 'bg-gray-300 text-gray-800 hover:bg-gray-400',
        popup: 'w-[400px] text-sm',
      },
    });
  };

  const download = async () => {
    setRefundsInfo([]);
    if (CVs.length > 0) {
      const result = await request({
        url: `${controllers.refund}getRefundsInfo`,
        type: requestTypes.post,
        body: CVs,
        setLoading,
      });

      if (result.code !== responseTypes.error) {
        const sortedResult = result.result.sort(
          (a, b) => a.branchId - b.branchId,
        );

        const groupedByBranch = sortedResult.reduce((acc, current) => {
          if (!acc[current.branchId]) {
            acc[current.branchId] = [];
          }
          acc[current.branchId].push(current);
          return acc;
        }, {});
        setRefundsInfo(groupedByBranch);
        Object.keys(groupedByBranch).forEach((branchId) => {
          exportToExcel(
            getRefundOnSaveData(groupedByBranch[branchId]),
            `refunds-branch-${branchId}`,
          );
        });
      } else {
        showSwal(result.code.toLowerCase());
      }
    }
  };

  return (
    <div>
      <div className="mt-8 mb-5 text-lg text-blue-800">REFUND</div>
      <div className="w-[500px] min-h-[110px] mx-auto border-[1px] border-gray-300 rounded-[20px] relative">
        <input
          value={CVInput}
          onKeyDown={handleKeyPress}
          onChange={(e) => SetCVInput(e.target.value)}
          type="text"
          placeholder="Enter CV..."
          className="w-full p-2 border border-b-gray-300 rounded-t-[20px] focus:outline-none focus:ring-[1px] focus:ring-blue-900 text-xs"
        />
        <div
          onClick={onEnterMethod}
          className="absolute text-white bg-blue-900 p-[9px] px-4 top-0 right-0 rounded-tr-[20px] text-xs cursor-pointer"
        >
          ENTER
        </div>
        <div className="w-full text-left px-2 py-1 text-sm">
          {CVs.map((item, index) => {
            return (
              <CVItem
                key={index}
                number={item}
                onRemove={() => onRemoveMethod(index)}
              />
            );
          })}
        </div>
        <div className="absolute bottom-1 w-full">
          <div
            onClick={download}
            className={classNames(
              'bg-red-800 text-white inline-block px-10 rounded-[20px] cursor-pointer hover:bg-red-900 hover:transition-all hover:duration-300',
              loading ? 'hidden' : null,
            )}
          >
            GET REFUND INFO
          </div>
          <div
            className={classNames(
              'w-full flex justify-center items-center',
              !loading ? 'hidden' : null,
            )}
          >
            <img className="w-8 h-8" src={loadingGif} />
          </div>
        </div>
      </div>
      <div className="w-1/3 min-w-[500px] mx-auto py-5">
        {Object.keys(refundInfo).map((item, index) => (
          <>
            <div className="text-blue-900 text-lg m-4">
              Branch {item} -{' Send to '}
              <span className="text-blue-500 underline">
                {refundContacts[item]}
              </span>
            </div>
            <CopyOnCipboardArea
              key={index}
              onCopyText={getOnCopyText(refundInfo[item])}
              text={stringTable.create(getRefundOnSaveData(refundInfo[item]))}
            />
          </>
        ))}
      </div>
    </div>
  );
};

export default Refund;
